const behavior = {
  getMyBehaviorTrackers: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetMyBehaviorTrackers(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Behavior_Tracker_Id
              Title 
              Description
              Student{
                Student_Id
                Name
              }
              Is_Archived
            }
          }`
      })
      .then(res => res.data.GetMyBehaviorTrackers);
  },

  getBehaviorTracker: async function(behaviorTrackerId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetBehaviorTracker(behaviorTrackerId: ` +
          parseInt(behaviorTrackerId) +
          `)
        {
          Behavior_Tracker_Id
          Title
          Description
          Student_Id
          Is_Archived
          Score_Template{
            Score_Template_Id
            Title
            Organization_Id
            Score_Template_Type_Id
            Score_Template_Inputs{
              Request
              Order
              Input_Data
              Score_Template_Input_Type{
                Score_Template_Input_Type_Id
                Title
              }
            }
          }
          Settings{
            Behavior_Setting_Id
            Title
            Description
          }
          Behavior_Tracker_Scores(userId: ` + parseInt(this.$store.getters.user.User_Id) + `){
            Behavior_Tracker_Score_Id
            Behavior_Setting_Id
            Date
            Value
          }
          Users{
            User_Id
          }
        }
      }
      `
      })
      .then(res => res.data.GetBehaviorTracker);
  },

  getMyBehaviorSettings: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
          GetMyBehaviorSettings(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Behavior_Setting_Id
              Title
              Description
            }
          }`
      })
      .then(res => res.data.GetMyBehaviorSettings);
  },

  createBehaviorTracker: async function(behaviorTrackerToCreate) {
    const query = ` mutation($title: String!, $description: String, $studentId: Int!, $scoreTemplateId: Int!) {
      CreateBehaviorTracker(title: $title, description: $description, studentId: $studentId, scoreTemplateId: $scoreTemplateId){
        Behavior_Tracker_Id
      }
    }`;
    const variables = {
      title: behaviorTrackerToCreate.Title,
      description: behaviorTrackerToCreate.Description,
      studentId: parseInt(behaviorTrackerToCreate.Student_Id),
      scoreTemplateId: parseInt(
        behaviorTrackerToCreate.Score_Template.Score_Template_Id
      )
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      behaviorTrackerToCreate.Behavior_Tracker_Id =
        res.data.CreateBehaviorTracker.Behavior_Tracker_Id;
      return behaviorTrackerToCreate;
    });
  },

  updateBehaviorTracker: async function(behaviorTrackerToUpdate) {
    const query = ` mutation($behaviorTrackerId: Int!, $title: String!, $description: String, $studentId: Int!, $scoreTemplateId: Int!) {
      UpdateBehaviorTracker(behaviorTrackerId: $behaviorTrackerId, title: $title, description: $description, studentId: $studentId, scoreTemplateId: $scoreTemplateId){
        Behavior_Tracker_Id
      }
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerToUpdate.Behavior_Tracker_Id),
      title: behaviorTrackerToUpdate.Title,
      description: behaviorTrackerToUpdate.Description,
      studentId: parseInt(behaviorTrackerToUpdate.Student_Id),
      scoreTemplateId: parseInt(
        behaviorTrackerToUpdate.Score_Template.Score_Template_Id
      )
    };
    return this.$store.getters.fetcher({ query, variables }).then(() => {
      return behaviorTrackerToUpdate;
    });
  },

  createBehaviorTrackerSettings: async function(
    behaviorTrackerId,
    behaviorSettingIds
  ) {
    const query = ` mutation($behaviorTrackerId: Int!, $behaviorSettingIds: [Int]!) {
      CreateBehaviorTrackerSettings(behaviorTrackerId: $behaviorTrackerId, behaviorSettingIds: $behaviorSettingIds){
        Behavior_Tracker_Setting_Id
      }
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerId),
      behaviorSettingIds: behaviorSettingIds.map(i => parseInt(i))
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.CreateBehaviorTrackerSettings);
  },

  createBehaviorTrackerUsersAssignments: async function(
    behaviorTrackerId,
    userIds
  ) {
    const query = ` mutation($behaviorTrackerId: Int!, $userIds: [Int]!) {
      CreateBehaviorTrackerUserAssignments(behaviorTrackerId: $behaviorTrackerId, userIds: $userIds){
        Behavior_Tracker_User_Assignment_Id
      }
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerId),
      userIds: userIds.map(i => parseInt(i))
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.CreateBehaviorTrackerUserAssignments);
  },

  removeBehaviorTrackerUsersAssignments: async function(
    behaviorTrackerId,
    userIds
  ) {
    const query = ` mutation($behaviorTrackerId: Int!, $userIds: [Int]!) {
      RemoveBehaviorTrackerUsersAssignments(behaviorTrackerId: $behaviorTrackerId, userIds: $userIds)
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerId),
      userIds: userIds.map(i => parseInt(i))
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.RemoveBehaviorTrackerUsersAssignments);
  },

  archiveBehaviorTracker: async function(behaviorTrackerId) {
    const query = ` mutation($behaviorTrackerId: Int!) {
      ArchiveBehaviorTracker(behaviorTrackerId: $behaviorTrackerId)
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.ArchiveBehaviorTracker);
  },

  unarchiveBehaviorTracker: async function(behaviorTrackerId) {
    const query = ` mutation($behaviorTrackerId: Int!) {
      UnarchiveBehaviorTracker(behaviorTrackerId: $behaviorTrackerId)
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.UnarchiveBehaviorTracker);
  },

  deleteBehaviorTracker: async function(behaviorTrackerId) {
    const query = ` mutation($behaviorTrackerId: Int!) {
      DELETEBEHAVIORTRACKER(behaviorTrackerId: $behaviorTrackerId)
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerId)
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data.DELETEBEHAVIORTRACKER);
  },

  createBehaviorTrackerScore: async function(
    behaviorTrackerId,
    behaviorSettingId,
    date,
    inputs
  ) {
    const query = ` mutation($behaviorTrackerId: Int!, $behaviorSettingId: Int!, $date: Date!, $value: String!, $userId: Int!) {
      CreateBehaviorTrackerScore(behaviorTrackerId: $behaviorTrackerId, behaviorSettingId: $behaviorSettingId, date: $date, value: $value, userId: $userId  ){
        Behavior_Tracker_Score_Id
      }
    }`;
    const variables = {
      behaviorTrackerId: parseInt(behaviorTrackerId),
      date: date,
      value: JSON.stringify(inputs),
      behaviorSettingId: parseInt(behaviorSettingId),
      userId: parseInt(this.$store.getters.user.User_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreateBehaviorTrackerScore;
    });
  },

  updateBehaviorTrackerScore: async function(
    behaviorTrackerScoreId,
    behaviorTrackerId,
    behaviorSettingId,
    date,
    inputs
  ) {
    const query = ` mutation($behaviorTrackerScoreId: Int!, $behaviorTrackerId: Int!, $behaviorSettingId: Int!, $date: Date!, $value: String!, $userId: Int!) {
      UpdateBehaviorTrackerScore(behaviorTrackerScoreId: $behaviorTrackerScoreId, behaviorTrackerId: $behaviorTrackerId, behaviorSettingId: $behaviorSettingId, date: $date, value: $value, userId: $userId  ){
        Behavior_Tracker_Score_Id
        Date
      }
    }`;
    const variables = {
      behaviorTrackerScoreId: parseInt(behaviorTrackerScoreId),
      behaviorTrackerId: parseInt(behaviorTrackerId),
      date: date,
      value: JSON.stringify(inputs),
      behaviorSettingId: parseInt(behaviorSettingId),
      userId: parseInt(this.$store.getters.user.User_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.UpdateBehaviorTrackerScore;
    });
  },

  createBehaviorSetting: async function(title, description, organizationId) {
    const query = ` mutation($title: String!, $description: String!, $organizationId: Int!) {
      CreateBehaviorSetting(title: $title, description: $description, organizationId: $organizationId){
        Behavior_Setting_Id
      }
    }`;
    const variables = {
      title: title,
      description: description,
      organizationId: parseInt(organizationId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return {
        Behavior_Setting_Id: res.data.CreateBehaviorSetting.Behavior_Setting_Id,
        Title: title,
        Description: description
      };
    });
  }
};

export { behavior };
